import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dailylog-submitter-submit',
  templateUrl: './submitter-submit.component.html',
  styleUrls: ['./submitter-submit.component.sass']
})

export class SubmitterSubmitContent {

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {

  }

  ngOnInit() {
  }

  confirm() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}